import Vue from 'vue'
import App from './App.vue'
import router from './router'
import md5 from 'js-md5'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import {
	api
} from './server/api'

Vue.use(ElementUI, { locale });
Vue.config.productionTip = false
// 接口挂在原型上
Vue.prototype.$api = api
// 图片上传路径
Vue.prototype.imageUrl = 'http://39.105.212.82/api/pc/user/upload'
// md5加密
Vue.prototype.$md5 = md5;

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
